export default "__VITE_ASSET__CfZi__$m__"